<template>
  <!--支付组件1招聘会定展2套餐购买-->
  <div v-if="formData.status === 1">
    <div v-if="formData.status === 1" class="pay">

      <div class="title"><rectCom/>支付方式</div>
      <el-radio-group v-model="payMode" :disabled="!!(formData.remittanceVoucher)">
        <template v-if="formData.payMode!=3">
          <el-radio v-if="payModes.includes(1)" :label="1" border>支付宝</el-radio>
          <el-radio v-if="payModes.includes(2)" :label="2" border>微信</el-radio>
          <el-radio v-if="payModes.includes(4)" :label="4" border>套餐划扣</el-radio>
        </template>
        <template v-else>
          <el-radio v-if="payModes.includes(3)" :label="3" border>对公打款</el-radio>
        </template>
      </el-radio-group>

      <el-row v-if="false" :gutter="20">
        <el-col :span="6">
          <div v-if="payModes.includes(1)" class="pay_mode">
            <span
              :class="{ isActive: payMode === 1 }"
              class="pay_mode_check click"
              @click="changePayMode(1)"
            />
            <img src="../../static/enterprise/alipay.png" alt="" >
            <span class="pay_mode_desc">支付宝</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div v-if="payModes.includes(2)" class="pay_mode">
            <span
              :class="{ isActive: payMode === 2 }"
              class="pay_mode_check click"
              @click="changePayMode(2)"
            />
            <img src="../../static/enterprise/wechat_pay.png" alt="" >
            <span class="pay_mode_desc">微信</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div v-if="payModes.includes(3)" class="pay_mode">
            <span
              :class="{ isActive: payMode === 3 }"
              class="pay_mode_check click"
              @click="changePayMode(3)"
            />
            <img src="../../static/enterprise/union_pay.png" alt="" >
            <span class="pay_mode_desc">对公打款</span>
          </div>

        </el-col>
        <el-col :span="6">
          <div v-if="payModes.includes(4)" class="pay_mode">
            <span
              :class="{ isActive: payMode === 4 }"
              class="pay_mode_check click"
              @click="changePayMode(4)"
            />
            <img src="../../static/enterprise/vip.png" alt="" >
            <span class="pay_mode_desc">套餐划扣</span>
          </div>
        </el-col>
      </el-row>

      <div v-if=" payMode === 3" class="remind">（*公对公打款需审核通过以后方可生效）</div>
      <el-divider class="margin-tb-lg"/>

      <!--底部支付-->
      <div class="cost">
        应付总额：<span class="flag">¥{{ payMode != 4 ? formData.amount : 0 }}</span>
      </div>

    </div>

    <div class="buttons">
      <el-button type="primary" class="backBtn" @click="toBack">
        返回
      </el-button>

      <el-button
        v-if="formData.remittanceVoucher" @click="offline_pay_info"
      >
        修改凭证
      </el-button>

      <el-button
        v-else
        :disabled="!payMode"
        type="primary"
        @click="handleConfirm"
      >
        确定支付
      </el-button>

    </div>
  </div>
</template>
<script>
import rect from '@/model/rect'
import { mapState } from 'vuex'
export default {
  components: {
    rectCom: rect
  },
  props: {
    cost: {
      type: Number,
      default() {
        return 0
      }
    },
    formData: {
      type: Object,
      default() {
        return {}
      }
    },
    // 默认是来自招聘定展支付，'1'是来自套餐购买
    from: {
      type: String,
      default() {
        return ''
      }
    },
    payModes: {
      type: String,
      default() {
        return ''
      }
    },
    // 能否采用套餐划扣
    isVipPay: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      payMode: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.base.userInfo
    })
  },
  watch: {
    formData: {
      handler() {
        if (this.formData.payMode === 3 || this.formData.remittanceVoucher) {
          this.payMode = 3
        }
      },
      deep: true
    }
  },

  methods: {
    toBack() {
      this.$router.back()
    },
    changePayMode(payMode) {
      this.payMode = payMode
    },
    handleConfirm() {
      this.$emit('confirm', this.payMode)
    },
    offline_pay_info() {
      this.$emit('confirm', 3)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/enterprise_color.scss";
@import "@/assets/css/buttons.scss";
//招聘会
.boothPay {
  margin-top: 30px;
}
.pay {
  .title {
    font-size: 16px;
    margin-bottom: 30px;
    color: #333;
  }
  &_mode {
    display: inline-block;
    width: 250px;
    height: 60px;
    border: 1px solid #f1f1f1;
    position: relative;
    margin-right: 50px;
    border-radius: 3px;
    &_check {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 20px;
      background: #f1f1f1;
      position: absolute;
      top: 50%;
      margin-top: -10px;
      left: 30px;
      cursor: pointer;
    }
    .isActive {
      background: $blue;
    }
    img {
      position: absolute;
      display: inline-block;
      left: 75px;
      top: 50%;
      margin-top: -25px;
    }
    &_desc {
      display: inline-block;
      position: absolute;
      color: #666;
      line-height: 30px;
      top: 50%;
      margin-top: -15px;
      left: 135px;
    }
  }
}
.remind {
  float: right;
  color: $red;
}
.line {
  margin-top: 30px;
  height: 2px;
  background: #dedede;
}
.cost {
  //20+10即可
  margin: 30px 0 10px 0;
  .flag {
    color: $star;
    font-size: 20px;
  }
}
.buttons {
  position: relative;
  text-align: center;
  //已经有20px
  margin: 30px 0 10px 0;
  .backBtn {
    width: 110px;
  }
}
</style>



// WEBPACK FOOTER //
// src/model/pay.vue